/* eslint-disable react/button-has-type */
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import { selectSelectedAppKey } from '../../../../../../../scanline/redux/WebsiteExperimental/selectors';
import { detailsMap } from '../../../../content';
import RequestMoreInfoButton from '../../../RequestMorInfoButton';
import ScheduleFreeTrialButton from '../../../ScheduleFreeTrialButton';

import './Original.v2.scss';

const VARIANT = 'original-v2';

const mapStateToProps = state => {
	const { websiteExperimental } = state;
	return {
		appKey: selectSelectedAppKey(websiteExperimental)
	};
};

const Original = ({ appKey }) => {
	const obj = useMemo(() => detailsMap[appKey], [appKey]);
	return (
		<div className={`details-${VARIANT}-wrapper`}>
			<h1 className="title">{obj.title}</h1>
			<hr />
			<p className="body">{obj.details}</p>
			<div className="actions">
				<RequestMoreInfoButton appKey={appKey} />
				<ScheduleFreeTrialButton appKey={appKey} />
			</div>
		</div>
	);
};

export default connect(mapStateToProps)(Original);
